export function FactionBadge({ faction, active }) {
  const key = faction.toLowerCase().replaceAll("/", "-").replaceAll(" ", "-").replace(/-+/g, "-");
  return (
    <div className={`faction-badge ${active ? "is-active" : ""}`} data-testid={`faction-badge-${key}`} aria-hidden="true">
      <svg viewBox="0 0 64 64">
        {faction.includes("APEX") ? (
          <>
            <path d="M32 8 L52 50 L32 41 L12 50 Z" />
            <path d="M32 18 L39 39 L32 35 L25 39 Z" />
          </>
        ) : null}
        {faction === "BLACK-OPS NET" ? (
          <>
            <circle cx="18" cy="18" r="6" />
            <circle cx="46" cy="18" r="6" />
            <circle cx="32" cy="42" r="7" />
            <path d="M23 21 L28 36 M41 21 L36 36 M24 18 L40 18" />
          </>
        ) : null}
        {faction === "SCRAPPER" ? (
          <>
            <circle cx="32" cy="32" r="14" />
            <path d="M32 10 V20 M32 44 V54 M10 32 H20 M44 32 H54 M17 17 L24 24 M40 40 L47 47 M47 17 L40 24 M24 40 L17 47" />
          </>
        ) : null}
        {faction === "SAFE ZONE ARMY" ? (
          <>
            <path d="M32 8 L52 16 V32 C52 44 43 53 32 58 C21 53 12 44 12 32 V16 Z" />
            <path d="M32 18 V44 M22 30 H42" />
          </>
        ) : null}
        {faction === "WASTELAND RUNNER" ? (
          <>
            <path d="M12 50 C24 42 20 28 32 24 C44 20 40 12 52 8" />
            <path d="M12 50 L20 48 M30 24 L38 24 M48 10 L52 18" />
            <circle cx="12" cy="50" r="4" />
            <circle cx="52" cy="8" r="4" />
          </>
        ) : null}
        {faction === "UNAFFILIATED" ? (
          <>
            <path d="M18 12 A24 24 0 1 0 46 52" />
            <path d="M18 12 L30 24 M46 52 L34 40 M18 52 L46 12" />
          </>
        ) : null}
      </svg>
    </div>
  );
}
